import { useSelector } from "react-redux"
import { State } from "store"

const useTypedSelector = <R>(
  selector: (state: State) => R,
  comparator?: (a: any, b: any) => boolean,
) => useSelector<State, R>(selector, comparator)

export default useTypedSelector
